
//前四顆按下去會進到下一層
//邏輯在page裡面做
//disabled的樣式不明顯


// import {  ACTIONBARWORD } from '../../../enum/enum';

export default {
  name: 'actionbar',
  components: {},
  props: {
    iconList: {
      type: Array,
      required: false,
      default: [
        {
          name: 'delete',
          val: 'delete',
          disabled: false
        },
        {
          name: 'download',
          val: 'download',
          disabled: true
        },
        {
          name: 'icon-add',
          val: 'icon-add',
          disabled: false
        },
        {
          name: 'icon-search',
          val: 'icon-search',
          disabled: false
        },
      ],
    },
  },
  data() {
    return {
      orgX: null,
      orgY: null,
      detail: '',
      showDetail: null,
      left: null,
      top: null,
    }
  },
  computed: {
    itemName() {

      if (this.detail.isI18n) {
        return this.$t(this.detail.isI18n)
      } else {
        return this.detail.title
      }
      // return Object.keys(ACTIONBARWORD).find(key => ACTIONBARWORD[key] === this.detail); 
    },
    itemClass() {
      return {
        left: `${this.left - this.orgX}px`,
        top: `${this.top + 60 - this.orgY}px`,

      };
    },
  },
  mounted() {
    let target = this.$refs.actionbar;  //計算原本此組件的絕對位置
    this.orgX = target.getBoundingClientRect().x;
    this.orgY = target.getBoundingClientRect().y;
    this.left = this.orgX;
    this.top = this.orgY;
  },
  methods: {
    showEx(e, index, v, item) {
      // if (!this.iconList[index].disabled) {  // 11/25 changed: disable show tooltips from pm
        this.left = e.target.getBoundingClientRect().left;
        this.top = e.target.getBoundingClientRect().top;
        if (v) {

          this.detail = item
        } else {
          this.detail = '';
        }
      // }

    },
    onClick(v) {
      if (!v.disabled) {
        this.$emit('actionBarClick', v.val)
      }
    },
    getImgUrl(pet) {
      let images = require.context('../../../assets/images', false, /\.svg$/)
      // console.log(pet,'images',images)
      return images('./' + pet + ".svg")
    }
  }
}


